// A téma !important-tal színezi a naptári napokat, ezért itt is szükség van rá
const DROUGHT_STATUS_COLORS = {
    drought: { backgroundColor: '#630303 !important', color: '#ffffff' },
    noDrought: { backgroundColor: '#15803d !important', color: '#ffffff' },
    unknown: { backgroundColor: '#6b7280 !important', color: '#ffffff' },
};

/** A naptári nap színe az adott napi aszály állapot szerint (a kárriasztással egyező paletta). */
export const getDroughtStatusColors = (isDrought) => {
    if (isDrought === true) {
        return DROUGHT_STATUS_COLORS.drought;
    }

    if (isDrought === false) {
        return DROUGHT_STATUS_COLORS.noDrought;
    }

    return DROUGHT_STATUS_COLORS.unknown;
};

export const getDroughtStatusLabel = (isDrought) => {
    if (isDrought === true) {
        return 'Aszályos';
    }

    if (isDrought === false) {
        return 'Nem aszályos';
    }

    return 'Nem meghatározható';
};
